import React from 'react';
import { useMediaQuery } from 'hooks';
import { error } from 'static/icons/resizable';
import { Icon } from 'view/atoms';
import { NoArchiveContentProps } from './NoActiveContent.model';
import * as S from './NoActive.styles';

export const NoArchiveContent = ({
  title,
  description,
  children,
}: NoArchiveContentProps) => {
  const { mobile, tablet } = useMediaQuery();

  const isMobile = mobile || tablet;

  return (
    <S.ContentBox>
      <Icon src={error} />

      <S.Title kind={isMobile ? 'h1' : 'h2'} color='gray1'>
        {title}
      </S.Title>

      <S.Description kind='body' color='gray1'>
        {description}
      </S.Description>

      {children}
    </S.ContentBox>
  );
};
